import styled from 'styled-components';

import { LinkButton as BaseLinkButton } from 'components/link-button';
import { primitive } from 'styles/constants/primitives';

export const Container = styled.div`
  display: grid;
`;

export const LinkButton = styled(BaseLinkButton)`
  font-family: ${Styles.fontFamily.body};
  color: ${primitive.th.$alwaysRed};
  font-size: 0.813rem;
  line-height: 1.125rem;
  text-align: left;
  padding: 0;
  margin: 0;
`;
